import { render, staticRenderFns } from "./FormFieldSsn.vue?vue&type=template&id=70589286&scoped=true"
import script from "./FormFieldSsn.vue?vue&type=script&lang=js"
export * from "./FormFieldSsn.vue?vue&type=script&lang=js"
import style0 from "./FormFieldSsn.vue?vue&type=style&index=0&id=70589286&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.43_babel-core@6.26.3_supports-color@7.2.0__css_4ebb8a9bdd1166ae2f68e8a453c2f580/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70589286",
  null
  
)

export default component.exports